import React, { useMemo } from 'react';
import { InView } from 'react-intersection-observer';

import Spinner from '@components/Spinner';
import useEventTracking from '@hooks/useEventTracking';
import useRecommendedReporters from '@hooks/useRecommendedReporters';
import { impression } from '@tracking';

import ReporterCard from './ReporterCard';
import MyTISection from './Section';
import { MY_TI_ENGAGEMENT_LABELS, MY_TI_SECTION_IDS } from './constants';
import useRegisterSection from './useRegisterSection';

const MyTIReporters = () => {
  const { trackEvent } = useEventTracking();
  const { reporters, followsReporters, isLoadingReporters } = useRecommendedReporters();

  const reportersDisplayText = useMemo(() => {
    if (!reporters) return MY_TI_ENGAGEMENT_LABELS.NotEngaged.Reporters;

    return followsReporters
      ? MY_TI_ENGAGEMENT_LABELS.Engaged.Reporters
      : MY_TI_ENGAGEMENT_LABELS.NotEngaged.Reporters;
  }, [followsReporters, reporters]);

  useRegisterSection(MY_TI_SECTION_IDS.Reporters, isLoadingReporters || !!reporters?.length);

  if (!isLoadingReporters && !reporters?.length) return null;

  return (
    <MyTISection
      id={MY_TI_SECTION_IDS.Reporters}
      highlight={reportersDisplayText.label}
      subtitle={reportersDisplayText.subtitle}
      title={reportersDisplayText.title}
    >
      <InView
        onChange={(inView) => {
          inView && trackEvent(impression({ impressionElement: MY_TI_SECTION_IDS.Reporters }));
        }}
        triggerOnce
      >
        <div className="flex flex-row flex-wrap gap-32 md:justify-between md:gap-64 *:md:max-w-[374px] lg:flex-nowrap">
          {!isLoadingReporters && reporters ? (
            reporters.map((reporter) => <ReporterCard key={reporter.id} reporter={reporter} />)
          ) : (
            <Spinner marginY="small" />
          )}
        </div>
      </InView>
    </MyTISection>
  );
};

export default MyTIReporters;
